<template>
    <div>
        <el-form-item :label="$t('竖向铺满')">
            <el-switch
                v-model="data.full"
                @change="fullChange"
                size="mini">
            </el-switch>
        </el-form-item>
        <el-form-item :label="$t('容器高度')">
            <el-input v-model="data.height" type="number" size="mini" :disabled="data.full">
                <template #append>
                    <l-select :clearable="false" style="width: 60px" :disabled="data.full" v-model="data.heightUnit" :options="[{
                        label: 'px', value: 'px'
                    }, {
                        label: '%', value: '%'
                    }]"></l-select>
                </template>
            </el-input>
        </el-form-item>
    </div>
</template>

<script>
export default {
    name: 'formPageDesignHeightVue',
    props: ['data'],
    data() {
        return {
            initVal: {
                full: true,
                height: 100,
                heightUnit: '%'
            }
        };
    },
    mounted() {
    },
    methods: {
        fullChange() {
            if (this.data.full) {
                this.data.height = 100;
                this.data.heightUnit = '%';
            }
        }
    }
}
</script>
<style scoped>
    
</style>